export const PRODUCT_PRESELECTED = 'PRODUCT_PRESELECTED';
export const PRESELECTION_RESET = 'PRESELECTION_RESET';
